import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["application", "lastConsolidatedRequest"];
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Amplitude from "@Shared/utils/amplitude";
import moment from "moment";
import { GET_CURRENT_APPLICATION, SESSION_TOKEN } from "./application-standalone-getters";
import { DEFAULT_DISCLAIMER_ID } from "@Shared/js/constants";
import { ADD_ARRAY_FIELD_BY_PATH, DELETE_ARRAY_FIELD_BY_PATH, SET_FIELD_BY_PATH, SET_CURRENT_APPLICATION_SCHEMA, SET_APPLICATION, SET_APPLICATION_METADATA, SET_DISCLAIMERS, MARK_APPLICATION_AS_SUBMITTED, SET_CONSOLIDATED_REQUEST, SET_CURRENT_APPLICATION_ID, SET_CURRENT_APPLICATION_CHANGES, SET_APPLICATION_FLOW, SET_CURRENT_COMPUTED_SCHEMA, MARK_APPLICATION_AS_HAVING_REQUESTED_DOCUMENTS, SET_IS_RETIRED_FIELD } from "@Client/@Modules/application-standalone/store/application-standalone-mutations";
import { GET_CURRENT_FLOW } from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { getCustomizationSchema, getApplication, getDisclaimers, updateApplication, submitApplication, getFullSIN } from "@Client/@Modules/deprecated-application/api/application-api";
import { cloneDeep } from "lodash";
import { getFillOutDisclaimers, getGuestFillOutApplication, getGuestFillOutSchema, submitFillOutApplication, updateFillOutApplication, updateFillOutLocalePreference } from "@Client/@Modules/guest-fill-out/api/guest-fill-out-api";
import { useApplicationQuestionsTranslations } from "@Client/@Composables/application-standalone/useApplicationQuestionsTranslations";
import { APPLICATION_FLOW } from "@Shared/@Types/application/application-enums";
export const TRANSFER_APPLICANT_FIELD_BY_PATH = "TRANSFER_APPLICANT_FIELD_BY_PATH";
export const DECRYPT_SIN = "DECRYPT_SIN";
export const LOAD_CUSTOMIZATION_SCHEMA = "LOAD_CUSTOMIZATION_SCHEMA";
export const LOAD_APPLICATION_DATA = "LOAD_APPLICATION_DATA";
export const LOAD_DISCLAIMERS = "LOAD_DISCLAIMERS";
export const UPDATE_APPLICATION = "UPDATE_APPLICATION";
export const SUBMIT_APPLICATION = "SUBMIT_APPLICATION";
export const UPDATE_LANGUAGE_PREFERENCE = "UPDATE_LANGUAGE_PREFERENCE";
export const UPDATE_APPLICATION_FIELD = "UPDATE_APPLICATION_FIELD";
export const UPDATE_IS_RETIRED_FIELD = "UPDATE_IS_RETIRED_FIELD";
const parseSourceTypeApiCall = (isFillOut, guestFillOutFunction, fullAppFunction) => {
  if (isFillOut) return guestFillOutFunction();
  return fullAppFunction();
};
const actions = {
  [LOAD_APPLICATION_DATA]: async (context, {
    newBrokerageId = null
  }) => {
    var _application$mortgage, _application$mortgage2;
    const {
      currentApplicationId: applicationId,
      isFillOut
    } = context.state;
    const guestFillOutFunction = async () => {
      const token = context.getters[SESSION_TOKEN];
      const applicationData = await getGuestFillOutApplication(token);
      context.commit(SET_CURRENT_APPLICATION_ID, {
        applicationId: applicationData.application.applicationId
      });
      return applicationData;
    };
    const fullAppFunction = () => {
      return getApplication(applicationId, null, newBrokerageId);
    };
    const _await$parseSourceTyp = await parseSourceTypeApiCall(isFillOut, guestFillOutFunction, fullAppFunction),
      {
        application = {},
        lastConsolidatedRequest
      } = _await$parseSourceTyp,
      applicationsMetadata = _objectWithoutProperties(_await$parseSourceTyp, _excluded);
    context.commit(SET_CONSOLIDATED_REQUEST, {
      consolidatedRequest: lastConsolidatedRequest
    });
    context.commit(SET_APPLICATION, {
      applicationObject: _objectSpread(_objectSpread({}, application), {}, {
        "mortgage-details": _objectSpread(_objectSpread({}, application["mortgage-details"]), {}, {
          "down-payment": (_application$mortgage = application == null ? void 0 : (_application$mortgage2 = application["mortgage-details"]) == null ? void 0 : _application$mortgage2["down-payment"]) != null ? _application$mortgage : [{
            amount: 0
          }]
        })
      }),
      applicationId: applicationId || application.applicationId
    });
    context.commit(SET_APPLICATION_METADATA, {
      applicationsMetadata,
      applicationId: applicationId || application.applicationId
    });
    context.commit(SET_APPLICATION_FLOW, {
      flow: application.flow
    });
  },
  [LOAD_DISCLAIMERS]: async context => {
    const {
      isFillOut
    } = context.state;
    const guestFillOutFunction = () => {
      const token = context.getters[SESSION_TOKEN];
      return getFillOutDisclaimers(token);
    };
    const fullAppFunction = () => getDisclaimers();
    const {
      disclaimers,
      defaultDisclaimerEnabled = true
    } = await parseSourceTypeApiCall(isFillOut, guestFillOutFunction, fullAppFunction);
    const onlyDisclaimers = _filterInstanceProperty(disclaimers).call(disclaimers, ({
      consent
    }) => !consent);
    const isDefaultDisclaimerEnabled = defaultDisclaimerEnabled != null ? defaultDisclaimerEnabled : onlyDisclaimers.length === 1;
    const enabledDisclaimers = _filterInstanceProperty(disclaimers).call(disclaimers, disclaimer => {
      const {
        id,
        enabled
      } = disclaimer;
      return enabled || id === DEFAULT_DISCLAIMER_ID && isDefaultDisclaimerEnabled;
    });
    context.commit(SET_DISCLAIMERS, {
      disclaimers: enabledDisclaimers
    });
  },
  [UPDATE_APPLICATION]: async (context, {
    newBrokerageId = null
  }) => {
    const application = context.getters[GET_CURRENT_APPLICATION];
    const {
      currentApplicationId: applicationId,
      applicationsMetadata,
      isFillOut,
      currentApplicationChanges
    } = context.state;
    const guestFillOutFunction = () => {
      const token = context.getters[SESSION_TOKEN];
      return updateFillOutApplication(token, cloneDeep(application), currentApplicationChanges);
    };
    const fullAppFunction = () => updateApplication(cloneDeep(application), applicationId, currentApplicationChanges, newBrokerageId);
    await parseSourceTypeApiCall(isFillOut, guestFillOutFunction, fullAppFunction);
    context.commit(SET_APPLICATION_METADATA, _objectSpread(_objectSpread({}, applicationsMetadata), {}, {
      updatedAt: moment().format()
    }));
    context.commit(SET_CURRENT_APPLICATION_CHANGES, {});
    Amplitude.logEvent("Application - application updated");
  },
  [LOAD_CUSTOMIZATION_SCHEMA]: async (context, {
    subdomain = ""
  } = {}) => {
    const {
      isFillOut
    } = context.state;
    const guestFillOutFunction = () => {
      const token = context.getters[SESSION_TOKEN];
      return getGuestFillOutSchema(token);
    };
    const fullAppFunction = () => getCustomizationSchema(subdomain);
    const schema = await parseSourceTypeApiCall(isFillOut, guestFillOutFunction, fullAppFunction);
    context.commit(SET_CURRENT_APPLICATION_SCHEMA, {
      schema
    });
    context.commit(SET_CURRENT_COMPUTED_SCHEMA, {
      schema
    });
  },
  [TRANSFER_APPLICANT_FIELD_BY_PATH]: (context, {
    sourcePath,
    targetPath,
    sourceElementIndex
  }) => {
    const sourceElement = context.getters.GET_FIELD_BY_PATH(`${sourcePath}[${sourceElementIndex}]`);
    const {
      getQuestionTranslationsByFieldPath
    } = useApplicationQuestionsTranslations(context.getters[GET_CURRENT_FLOW] || APPLICATION_FLOW.PURCHASE);
    context.commit(DELETE_ARRAY_FIELD_BY_PATH, {
      path: sourcePath,
      index: sourceElementIndex
    });
    context.commit(SET_CURRENT_APPLICATION_CHANGES, _objectSpread(_objectSpread({}, context.state.currentApplicationChanges), {}, {
      [sourcePath]: {
        value: context.getters.GET_FIELD_BY_PATH(sourcePath),
        i18n: getQuestionTranslationsByFieldPath(sourcePath)
      }
    }));
    context.commit(ADD_ARRAY_FIELD_BY_PATH, {
      path: targetPath,
      value: sourceElement
    });
    context.commit(SET_CURRENT_APPLICATION_CHANGES, _objectSpread(_objectSpread({}, context.state.currentApplicationChanges), {}, {
      [targetPath]: {
        value: context.getters.GET_FIELD_BY_PATH(targetPath),
        i18n: getQuestionTranslationsByFieldPath(targetPath)
      }
    }));
  },
  [SUBMIT_APPLICATION]: async (context, {
    newBrokerageId = null
  }) => {
    const {
      acceptedConsents = [],
      currentApplicationId: applicationId,
      isFillOut,
      flow,
      additionalInformation
    } = context.state;
    const acceptedConsentsIds = _mapInstanceProperty(acceptedConsents).call(acceptedConsents, ({
      id
    }) => id);
    const consentObtained = acceptedConsents.some(disclaimer => disclaimer.consent);
    const guestFillOutFunction = () => {
      const token = context.getters[SESSION_TOKEN];
      return submitFillOutApplication(token);
    };
    const fullAppFunction = () => submitApplication(consentObtained, acceptedConsentsIds, applicationId, flow, additionalInformation, newBrokerageId);
    const response = await parseSourceTypeApiCall(isFillOut, guestFillOutFunction, fullAppFunction);
    if (response && response.hasOwnProperty("hasRequestedDocs")) {
      context.commit(MARK_APPLICATION_AS_HAVING_REQUESTED_DOCUMENTS, {
        hasRequestedDocuments: response.hasRequestedDocs
      });
    }
    context.commit(MARK_APPLICATION_AS_SUBMITTED, {
      isConsolidatedRequest: context.getters["IS_CONSOLIDATED_REQUEST"],
      applicationId
    });
    Amplitude.logEvent("Application - application submitted");
  },
  [DECRYPT_SIN]: async (context, {
    applicantSinPath,
    applicantIndex
  }) => {
    const {
      currentApplicationId
    } = context.state;
    let sin = {};
    const currentSIN = context.getters.GET_FIELD_BY_PATH(applicantSinPath);
    if (currentSIN && currentSIN[3] !== "XXX") {
      sin = {
        1: currentSIN[1],
        2: currentSIN[2],
        3: currentSIN[3]
      };
    } else {
      ({
        sin
      } = await getFullSIN(applicantIndex, currentApplicationId));
    }
    context.dispatch(UPDATE_APPLICATION_FIELD, {
      path: applicantSinPath,
      value: sin
    });
  },
  [UPDATE_LANGUAGE_PREFERENCE]: async (context, {
    localeLanguage
  }) => {
    const {
      isFillOut
    } = context.state;
    const guestFillOutFunction = async () => {
      const token = context.getters[SESSION_TOKEN];
      await updateFillOutLocalePreference(token, localeLanguage);
      context.commit("AccountStore/SET_ACCOUNT_DETAILS", {
        accountDetails: {
          localeLanguage
        }
      }, {
        root: true
      });
    };
    const fullAppFunction = async () => {
      await context.dispatch("AccountStore/UPDATE_LOCALE_PREFERENCES", {
        localeLanguage
      }, {
        root: true
      });
    };
    await parseSourceTypeApiCall(isFillOut, guestFillOutFunction, fullAppFunction);
  },
  [UPDATE_APPLICATION_FIELD]: async (context, {
    path,
    value
  }) => {
    if (path === "[flow]") {
      context.commit(SET_APPLICATION_FLOW, {
        flow: value
      });
    }
    context.commit(SET_FIELD_BY_PATH, {
      path,
      value
    });
    const {
      getQuestionTranslationsByFieldPath
    } = useApplicationQuestionsTranslations(context.getters[GET_CURRENT_FLOW] || APPLICATION_FLOW.PURCHASE);
    context.commit(SET_CURRENT_APPLICATION_CHANGES, _objectSpread(_objectSpread({}, context.state.currentApplicationChanges), {}, {
      [path]: {
        value,
        i18n: getQuestionTranslationsByFieldPath(path)
      }
    }));
  },
  [UPDATE_IS_RETIRED_FIELD]: async (context, data) => {
    context.commit(SET_IS_RETIRED_FIELD, data);
  }
};
export default actions;